import { render, staticRenderFns } from "./storeSelectConfig.vue?vue&type=template&id=572a79d4&scoped=true"
import script from "./storeSelectConfig.vue?vue&type=script&lang=js"
export * from "./storeSelectConfig.vue?vue&type=script&lang=js"
import style0 from "./storeSelectConfig.vue?vue&type=style&index=0&id=572a79d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a79d4",
  null
  
)

export default component.exports